import { render, staticRenderFns } from "./ErrorInfo.vue?vue&type=template&id=ec30e656&"
import script from "./ErrorInfo.vue?vue&type=script&lang=js&"
export * from "./ErrorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports